import React, { useState } from "react";
import styles from '../styles/editMessage.module.scss'
import Icon from "@/wmCompoments/Icon";
import { IconName } from "@/wmCompoments/Icon/iconTypes";
import { useDelete, useGetUnreadForType, useRead, useReadAll } from "../hooks/useMessageCenter";
import { useMessageContext } from "../context";
import Toast from "@/wmCompoments/toast";
import ErrorMessageDialog from "@/antComponent/errorMessageDialog";
import { useTranslation } from "react-i18next";

const EditMessage = () => {
  const { t } = useTranslation('messageCenter')

  // 获取当前上下文中的通用数据和方法
  const { selectedItem, mutateList, editor, setEditor, list, selectedIds, setSelectedIds } = useMessageContext();
  // 获取站内信未读数
  const { mutate } = useGetUnreadForType()
  // 全部已读
  const { trigger: triggerReadAll } = useReadAll()
  // 读取站内信 
  const { trigger, isMutating } = useRead()
  // 删除站内信
  const { trigger: triggerDelete } = useDelete()
  // 判定是否全选
  const allSelected = list?.length > 0 && list.every(msg => selectedIds.includes(msg.id));

  const items1 = [
    {
      icon: 'icon-message-edit',
      title: t('edit'),
      onclick: () => setEditor(!editor)
    },
    {
      icon: 'icon-message-read',
      title: t('allRead'),
      onclick: async () => {
        try {
          await triggerReadAll({
          brType: selectedItem?.brType,
          msgType: selectedItem?.msgType,
          userSystem: '1'
        })
        await Promise.all([mutate(), mutateList()])
        Toast.show(t('actionSuccess'))
        } catch(error: any){
          ErrorMessageDialog(error?.message ?? JSON.stringify(error));
        }
      }
    },
  ]

  const items2 = [
    {
      // icon: 'icon-general-arrow',
      title: t('complete'),
      onclick: () => {
        setEditor(!editor)     // 退出编辑
        setSelectedIds([]);    // 清空选中
      }
    },
    {
      icon: 'icon-message-read',
      title: t('markAsRead'),
      onclick: async () => {
        if (selectedIds.length === 0) {
          Toast.show(t('SelectMail'));
          return;
        }
        if (isMutating) {
          Toast.show(t('tooManyRequests'));
          return;
        }
        const ids = selectedIds.join(',');
        try {
          await trigger ({
            brType: selectedItem?.brType,
            msgType: selectedItem?.msgType,
            id: ids,
            userSystem: '1'
          })
          Toast.show(t('actionSuccess'));
          await Promise.all([mutate(), mutateList()]);
          setSelectedIds([]); // 清空选中
        } catch (error: any){
          ErrorMessageDialog(error?.message ?? JSON.stringify(error));
        }
      }
    },
    {
      icon: 'icon-message-delete',
      title: t('delete'),
      onclick: async () => {
        if (selectedIds.length === 0) {
          Toast.show(t('selectMessageFirst'));
          return;
        }
        const ids = selectedIds.join(',');
        try {
          await triggerDelete({
            brType: selectedItem?.brType,
            msgType: selectedItem?.msgType,
            id: ids,
            userSystem: '1'
          })
          await Promise.all([mutate(), mutateList()])
          setSelectedIds([]); // 删除后清空选中
          Toast.show(t('actionSuccess'))
        } catch (error: any) {
          ErrorMessageDialog(error?.message ?? JSON.stringify(error));
        }
      }
    },
    {
      icon: 'icon-message-choose',
      title: '全部',
      onclick: () => {
        if (allSelected) {
          setSelectedIds([]); // 全部已选 → 取消全选
        } else{
          const allIds = list?.map((msg) => msg.id) || []; // 获取当前所有消息id
          setSelectedIds(allIds);  // 否则 → 全选
        }
      }
    },
  ]

  const items = editor ? items2 : items1

  return (
    <div className={styles.editMessage}>
      {items.map((v,index)=>{
        const isAllIcon = v.icon === "icon-message-choose";
        const iconClass = isAllIcon
          ? `${styles.iconWrapper} ${allSelected ? styles.selected : ''}`
          : styles.icon;

        return <div key={index} onClick={v.onclick} className={styles.item}>
          {v.icon && <Icon name={v.icon as IconName} className={iconClass} />}
          <div className={`${!v.icon ? styles.active : ''}`}>{v.title}</div>
        </div>
      })}
    </div>
  )
}

export default EditMessage